import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Checkbox,
    Button,
} from "@mui/material";
import { useState } from "react";
import { CotacaoRealizada } from "../..";
import { confirm } from "material-ui-confirm";
import { ProdutoGerarOc } from "..";

export default function ModalSelecionarCotacao({
    open,
    produto,
    cotacoes,
    selectedCotacaoId,
    onSelect,
    onClose
}: ModalSelecionarCotacaoProps) {
    const [selectedId, setSelectedId] = useState<number | undefined>(selectedCotacaoId);

    const cotacoesDoProduto = cotacoes.map(cotacao => {
        const item = cotacao.itens.find(i => i.produto_id === produto.produto_id);
        if (!item) return null;
        return {
            cotacao_id: cotacao.id,
            fornecedor_nome: cotacao.fornecedor,
            fornecedor_codigo: String(cotacao.fornecedor_id),
            quantidade: item.quantidade,
            unidade_medida: item.unidade_medida,
            valor_unitario: Number(item.valor_unitario),
            valor_total: Number(item.valor_total),
            previsao_entrega: `${cotacao.prazo_entrega} DIAS`,
        };
    }).filter(Boolean).sort((a, b) => a!.valor_unitario - b!.valor_unitario) as Array<{
        cotacao_id: number;
        fornecedor_nome: string;
        fornecedor_codigo: string;
        quantidade: number;
        unidade_medida: string;
        valor_unitario: number;
        valor_total: number;
        previsao_entrega: string;

    }>;

    function handleSelect(id: number) {
        setSelectedId(id);
    }

    function handleConfirm() {
        onSelect(selectedId!);
        onClose();
    }


    return (
        <Dialog open={open} maxWidth="md" fullWidth>
            <DialogTitle>
                Listagem de cotações
            </DialogTitle>

            <DialogContent>
                <Typography variant="body1">
                    <b>Produto:</b> {produto.nome}
                </Typography>

                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            <TableCell><b>Fornecedor</b></TableCell>
                            <TableCell align="right"><b>Qtd. solicitada</b></TableCell>
                            <TableCell align="right"><b>Valor Unit.</b></TableCell>
                            <TableCell align="right"><b>Valor total</b></TableCell>
                            <TableCell align="right"><b>Prev. entrega</b></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {cotacoesDoProduto.map(cotacao => (
                            <TableRow key={cotacao.cotacao_id} hover>
                                <TableCell>
                                    <Checkbox
                                        checked={selectedId === cotacao.cotacao_id}
                                        onChange={() => handleSelect(cotacao.cotacao_id)}
                                    />
                                </TableCell>

                                <TableCell>
                                    {cotacao.fornecedor_codigo} - {cotacao.fornecedor_nome}
                                </TableCell>

                                <TableCell align="right">
                                    {cotacao.quantidade} {cotacao.unidade_medida}
                                </TableCell>

                                <TableCell align="right">
                                    R$ {Number(cotacao.valor_unitario).toFixed(2)}
                                </TableCell>

                                <TableCell align="right">
                                    R$ {Number(cotacao.valor_total).toFixed(2)}
                                </TableCell>

                                <TableCell align="right">
                                    {cotacao.previsao_entrega}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </DialogContent>

            <DialogActions sx={{ pr: 3, pb: 3 }}>
                <Box sx={{ flex: 1 }} />
                <Button
                    variant="text"
                    color="primary"
                    onClick={onClose}
                >
                    Cancelar
                </Button>

                <Button
                    variant="contained"
                    color="primary"
                    disabled={selectedId === undefined}
                    onClick={() => {
                        if (selectedId === undefined) return;

                        const cotacaoMaisBarata = cotacoesDoProduto.reduce((prev, current) =>
                            prev.valor_total < current.valor_total ? prev : current
                        );

                        if (selectedId === cotacaoMaisBarata.cotacao_id) {
                            handleConfirm();
                        } else {
                            confirm({
                                title: "Confirmação",
                                description: "Um produto mais caro foi selecionado, deseja continuar?"
                            }).then(() => {
                                handleConfirm();
                            }).catch(() => {
                            });
                        }
                    }}
                >
                    Selecionar
                </Button>
            </DialogActions>
        </Dialog>
    );
}


interface ModalSelecionarCotacaoProps {
    open: boolean;
    produto: ProdutoGerarOc;
    cotacoes: CotacaoRealizada[];
    selectedCotacaoId: number | undefined;
    onSelect: (cotacaoId: number) => void;
    onClose: () => void;
}